import { addRendition } from '@shared/utils/photoRendition';
import { MEDIA_SERVICE } from './steps/CardDesign/config';

export const applyRenditionIfMediaServiceUrl = (url: string) => {
  return url.startsWith(MEDIA_SERVICE) ? addRendition({ url, renditionSize: 'medium' }) : url;
};
